/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import {object, number} from 'yup'
import {Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'

import {
  useGetUserSalesTargetQuery,
  useUpdateUserSalesTargetMutation,
} from '../../../../../../services/cellcast'
import { useSelector } from 'react-redux'

export type Props = {
  show: boolean
  handleClose: () => void
}

const SalesTargetValidation = object().shape({
  salesTarget: number().min(0).required().default(0)
})

const SalesTarget: React.FC<Props> = ({ show, handleClose }) => {
  const ProfileDetatileState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)

  const {
    data: salesTargetData,
    refetch: refetchSalesTarget,
  } = useGetUserSalesTargetQuery({
    userId: ProfileDetatileState?._id
  })

  const [updateUserSalesTarget, updateTarget] = useUpdateUserSalesTargetMutation();

  useEffect(() => {
    if (show) {
      refetchSalesTarget();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])
  
  const updateSalesTarget = async (target: number) => {
    try {
      await updateUserSalesTarget({
        userId: ProfileDetatileState?._id,
        target,
      }).unwrap()
      .then((res) => {
          refetchSalesTarget();
          toast.success(res.message)
          handleClose();
      });

    } catch (err) {
      toast.error('Failed to update sales target:')
      console.error('Failed to update sales target:', err);
    }
  };

  return (
    <Modal
      className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
      id='kt_inbox_compose'
      role='dialog'
      data-backdrop='false'
      aria-hidden='true'
      tabIndex='-1'
      show={show}
      animation={false}
    >
      <div className='modal-header'>
        <h2>Sales Target</h2>
        <div className='btn btn-icon btn-sm' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>
      <div className='modal-body'>
        <Formik
          initialValues={{
            salesTarget: salesTargetData?.data?.sales_target,
          }}
          validationSchema={SalesTargetValidation}
          onSubmit={(val: any, { setSubmitting }) => {
            setSubmitting(false)
            updateSalesTarget(val.salesTarget);
          }}
        >
          {() => (
            <Form>
              <div>
                <label htmlFor='password'>Target ($)</label>
                <div className='password-wrap mt-2'>
                  <Field
                    className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    type={'text'}
                    id='salesTarget'
                    name='salesTarget'
                    placeholder='9000'
                    inputMode='numeric'
                    pattern='[0-9]*'
                    onKeyDown={(e: any) => {
                      if (
                        ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(e.key)
                      ) {
                        return;
                      }
                      if (!/^\d$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
                <ErrorMessage name='password'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>
              </div>
              <div className='text-end mt-10 mb-10'>
                <button type='submit' className='btn btn-primary'>
                  Save
                  {updateTarget.isLoading ? (
                    <Spinner size='sm' />
                  ) : null}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export { SalesTarget }
